import React from "react";

var chevronLeftCircleSvg = function chevronLeftCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm9.707 2.793L6.914 8l2.793-2.793a1 1 0 1 0-1.414-1.414l-3.5 3.5a1 1 0 0 0 0 1.414l3.5 3.5a1 1 0 1 0 1.414-1.414z",
    fillRule: "evenodd"
  }));
};

chevronLeftCircleSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var chevronLeftCircle = {
  category: 'icon',
  colorable: true,
  name: 'chevronLeftCircle',
  svg: chevronLeftCircleSvg
};